import typeCheck from 'common/util/typeCheck';

export default function setMapCity({ state }, { lat, lng, zoom }) {
  typeCheck('lat::Number', lat);
  typeCheck('lng::Number', lng);
  typeCheck('zoom::Number', zoom);

  state.set(['listingsMapView', 'showResultsMatched'], true);
  state.set(['listingsMapView', 'showRedoSearch'], false);
  state.set(['listingsMapView', 'mapChanged'], false);
  state.set(['listingsMapView', 'mapCenter'], { lat, lng });
  state.set(['listingsMapView', 'mapZoomLevel'], zoom);
}
